import { render, staticRenderFns } from "./grupoexame.vue?vue&type=template&id=1481ac73"
import script from "./grupoexame.vue?vue&type=script&lang=js"
export * from "./grupoexame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports